import { render, staticRenderFns } from "./keyword-search.vue?vue&type=template&id=6e537e74&scoped=true"
import script from "./keyword-search.vue?vue&type=script&lang=js"
export * from "./keyword-search.vue?vue&type=script&lang=js"
import style0 from "./keyword-search.vue?vue&type=style&index=0&id=6e537e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e537e74",
  null
  
)

export default component.exports